import { render, staticRenderFns } from "./StrategicQuestionList.vue?vue&type=template&id=9dd32ab2"
import script from "./StrategicQuestionList.vue?vue&type=script&lang=js"
export * from "./StrategicQuestionList.vue?vue&type=script&lang=js"
import style0 from "./StrategicQuestionList.vue?vue&type=style&index=0&id=9dd32ab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports